module.exports = __webpack_public_path__ + "561d889f1b124e0fc70a55bdf6e3c113.jpg";